import {
  useMemo, useRef,
} from 'react';
import { useAuth } from '../../../../../../contexts/userContext/userContext';
import useTranslation from '../../../../../../hooks/translation/useTranslation';

export default function SuggestedStations({
  handleSubmit = () => {}, direction = 'departure',
}) {
  const ref = useRef(null);
  const { currentLanguage } = useTranslation();
  const { ticketBookingOptions } = useAuth();
  const { suggestedStations, stations } = ticketBookingOptions;

  const stationsMap = useMemo(() => {
    const map = new Map();
    stations?.forEach((station) => {
      map.set(station.value, station?.[`label_${currentLanguage}`] || station?.label_ka);
    });
    return map;
  }, [stations, currentLanguage]);

  return (
    <div className="grid relative">
      <div className="flex overflow-x-auto no-scrollbar items-center" ref={ref}>
        {suggestedStations?.filter(
          (item) => item.direction === direction && stationsMap.has(item.station_code),
        )?.map((item) => {
          const station = stationsMap.get(item.station_code);
          if (!station) return null; // Skip if station not found in map
          return (
            <button
              type="button"
              className="border-transparent cursor-pointer !bg-transparent whitespace-nowrap text-primary"
              key={item.id}
              onClick={() => handleSubmit(item.station_code)}
            >
              {station}
            </button>
          );
        })}
      </div>
    </div>
  );
}
